import React from 'react';
import { useDispatch } from 'react-redux';
import { setModal } from '../../redux';
import CSWDeletePost from 'components/Post/components/CSWDeletePost';

export function useCSWDelete({
	onFailure,
	maxAttempts,
	getAttempts,
	setAttempts,
} = {}) {
	const dispatch = useDispatch();

	return (onSubmit, { message, email, keepLoader = true } = {}) => {
		dispatch(
			setModal(
				<CSWDeletePost
					show={true}
					showToggle={(value) => dispatch(setModal(value))}
					onSubmit={onSubmit}
					message={message}
					onFailure={onFailure}
					maxAttempts={maxAttempts}
					getAttempts={getAttempts}
					email={email}
					keepLoader={keepLoader}
					setAttempts={setAttempts}
				/>
			)
		);
	};
}
